import I18n from 'I18n';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITimeInput from 'UIComponents/input/UITimeInput';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
// @ts-expect-error Untyped module
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SchedulingPublishControls = ({
  scheduledPublishDate,
  setPublishDateDay,
  publishDateTime,
  setPublishDateTime,
  isReadOnlyMode,
  allowBackdating,
  maxPublishDate,
  onExitSchedulingClick
}) => {
  return /*#__PURE__*/_jsx(UIMultiColumn, {
    flush: true,
    children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(UIDateInput, {
          "data-test-id": "publishing-date-picker",
          maxValue: maxPublishDate,
          min: allowBackdating ? null : SimpleDate.fromMoment(I18n.moment.portalTz()),
          onChange: ({
            target: {
              value
            }
          }) => {
            setPublishDateDay(value);
          },
          value: scheduledPublishDate,
          readOnly: isReadOnlyMode
        })
      }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(UITimeInput, {
          value: publishDateTime,
          "data-test-id": "publishing-time-picker",
          use: "default",
          onChange: e => {
            setPublishDateTime(e.target.value);
          },
          readOnly: isReadOnlyMode,
          format: `LT [${I18n.moment.portalTz().format('z')}]`,
          interval: 15
        })
      }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
        horizontalAlign: "right",
        verticalAlign: "middle",
        className: "p-x-2",
        children: /*#__PURE__*/_jsx(UIIconButton, {
          use: "unstyled",
          onClick: onExitSchedulingClick,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "remove"
          })
        })
      })]
    })
  });
};
export default SchedulingPublishControls;